module.exports = __webpack_public_path__ + "img/v_5.e1cc8346.svg";